import React from 'react';
import { PageHeader } from './PageHeader';
import type { LegalPageContent } from '../data/legal';
interface LegalPageProps {
  content: LegalPageContent;
}
export function LegalPage({
  content
}: LegalPageProps) {
  return <>
      <PageHeader eyebrow="Legal" title={content.title} description={content.intro} crumbs={[{
      label: content.title
    }]} data-id="element-156" data-mp="98k4sx39erbx" />
      <section className="bg-white" data-id="element-157" data-mp="i75hibm1vc4s">
        <div className="mx-auto max-w-3xl px-6 py-16 sm:py-20 lg:px-8" data-id="element-158" data-mp="i6462614gnmj">
          <div className="space-y-10" data-id="element-159" data-mp="e6vd33dwots1">
            {content.sections.map(section => <div key={section.heading} data-id="element-160" data-mp="ry08tue5l1x3">
                <h2 className="font-serif text-[22px] text-navy-950" data-id="element-161" data-mp="rwp1jkli1c18">
                  {section.heading}
                </h2>
                {section.paragraphs.map(paragraph => <p key={paragraph.slice(0, 32)} className="mt-4 text-[16px] leading-relaxed text-navy-600" data-id="element-162" data-mp="11wfv9k28jn09">
                    {paragraph}
                  </p>)}
              </div>)}
          </div>
        </div>
      </section>
    </>;
}